"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = exports.PopupProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const web_log_1 = require("@snapchat/web-log");
const PopupContext = (0, react_1.createContext)(null);
/**
 * Helper component to render any ReactNode above all app content
 */
function PopupProvider({ children }) {
    const popupRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsxs)(PopupContext.Provider, { value: popupRef, children: [children, (0, jsx_runtime_1.jsx)("div", { ref: popupRef })] }));
}
exports.PopupProvider = PopupProvider;
/**
 * Helper component to create React Portal.
 */
function Popup({ children }) {
    const popupContext = (0, react_1.useContext)(PopupContext);
    if (!popupContext) {
        web_log_1.log.error("Popup Provider not found");
    }
    return popupContext?.current ? react_dom_1.default.createPortal(children, popupContext.current) : null;
}
exports.Popup = Popup;
//# sourceMappingURL=Popup.js.map